"use client";

import React from "react";

const services = [
  {
    title: "Project Mandates",
    description:
      "Exclusive mandates ensuring end-to-end sales and marketing solutions for your real estate projects.",
    image: "/images/mandate.webp",
  },
  {
    title: "Digital Marketing",
    description:
      "Strategic digital campaigns to boost your project visibility and generate quality leads.",
    image: "/images/digital-marketing.webp",
  },
  {
    title: "Channel Partner Network",
    description:
      "Robust network of trusted channel partners helping maximize your project's reach and sales.",
    image: "/images/channel-partner.webp",
  },
  {
    title: "Market Research",
    description:
      "In-depth analysis and insights to help you make data-driven decisions for your real estate investments.",
    image: "/images/market-research.webp",
  },
];

export default services;export const cardsData = [
    {
        category: "",
        title: "Deep Planet",
        src: "assets/delivered-projects/deep-plant.webp",
        content: <p>KHARGHAR, NAVI MUMBAI</p>,
    },
    {
        category: "",
        title: "Deep Visionare",
        src: "assets/delivered-projects/deepvisionaire.webp",
        content: <p>KHARGHAR, NAVI MUMBAI</p>,
    },
    {
        category: "",
        title: "Dev Residency",
        src: "assets/delivered-projects/dev-residency.webp",
        content: <p>KHARGHAR, NAVI MUMBAI</p>,
    },
     {
        category: "",
        title: "Rachna Enclave",
        src: "assets/delivered-projects/rachna-enclave.webp",
        content: <p>KHARGHAR, NAVI MUMBAI</p>,
    },
     {
        category: "",
        title: "Pushp Pinnacle",
        src: "assets/delivered-projects/pushp-pinnacle.webp",
        content: <p>KHARGHAR, NAVI MUMBAI</p>,
    },
    {
        category: "",
        title: "Sawan Majesity",
        src: "assets/delivered-projects/swan.webp",
        content: <p>TALOJA, NAVI MUMBAI</p>,
    },
    {
        category: "",
        title: "Gateway",
        src: "assets/delivered-projects/the-gatway.webp",
        content: <p>TALOJA, NAVI MUMBAI</p>,
    },
    {
        category: "",
        title: "Tharvani Sky View",
        src: "assets/delivered-projects/Tharvani-sky-view.webp",
        content: <p>KHARGHAR, NAVI MUMBAI</p>,
    },
];

